import React from "react"
import Loader from "react-loader-spinner"

const PhealLoader = ({ color = "black", width = 30, height = 30 }) => {
    return <Loader color={color} width={width} height={height} type="Circles" />
}

export default PhealLoader